import { useT } from '@/lib/i18n';

/** Shown while a lazily-loaded route chunk is fetched. */
export function RouteFallback() {
  const t = useT();
  return (
    <div className="grid min-h-dvh place-items-center text-sm text-muted">
      {t('ui.route_fallback.loading')}
    </div>
  );
}
